const REDIRECT_KEY = 'redirectTo'

const isSafePath = (value) =>
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')

export const setRedirectTo = (value) => {
  if (typeof localStorage === 'undefined') return
  if (!isSafePath(value)) return
  localStorage.setItem(REDIRECT_KEY, value)
}

export const getRedirectTo = () => {
  if (typeof localStorage === 'undefined') return null
  const value = localStorage.getItem(REDIRECT_KEY)
  return isSafePath(value) ? value : null
}

export const clearRedirectTo = () => {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(REDIRECT_KEY)
}

export const consumeRedirectTo = () => {
  const value = getRedirectTo()
  if (value) {
    clearRedirectTo()
  }
  return value
}
